module.exports = __webpack_public_path__ + "img/confirm-white.3a672095.svg";